'use client';

export { CSPProvider } from '@base-ui/react/csp-provider';
